export default __webpack_public_path__ + "static/media/States.ef356b25.svg";